import { useState, useEffect } from 'react';

import browser from '@openclassrooms/utils/browser';
import { getAppleConfig } from '@openclassrooms/common-app/social/services';

import SocialButton from './LoginButton';
import type { SocialLoginButtonProps } from './types';

const AppleLoginButton = ({
  onSuccess,
  isRegister = false,
  disabled = false,
}: SocialLoginButtonProps) => {
  const config = getAppleConfig();
  const [isAppleLibLoaded, setIsAppleLibLoaded] = useState(false);

  useEffect(() => {
    if (!(browser.window as any).AppleID) {
      browser.loadScript({ src: config.libUrl, onLoaded: () => setIsAppleLibLoaded(true) });
    } else {
      setIsAppleLibLoaded(true);
    }
  }, [config.libUrl]);

  const initAppleAuth = () => {
    (browser.window as any).AppleID.auth.init({
      clientId: config.clientId,
      scope: 'name email',
      redirectURI: `${window.location.origin}/login_check_apple`,
      usePopup: true,
    });
  };

  return (
    <SocialButton
      shouldDisplayAsIcon
      isRegister={isRegister}
      socialVariant="apple"
      disabled={disabled || !isAppleLibLoaded}
      onClick={async () => {
        initAppleAuth();

        try {
          const data = await (browser.window as any).AppleID.auth.signIn();
          onSuccess(data);
          // eslint-disable-next-line no-empty
        } catch (error) {}
      }}
    />
  );
};

export default AppleLoginButton;
